import { keepPreviousData, useQuery } from '@tanstack/react-query';
import { fetchProducts } from '../api/products.api';

export const useProducts = (filters: unknown) =>
  useQuery({
    queryKey: ['products', filters],
    queryFn: () => fetchProducts(filters),
    placeholderData: keepPreviousData,
  });
